<!-- List popup -->
<template>
	<div
		class="modal fade"
		id="keywordDescPopup"
		tabindex="-1"
		role="dialog"
		aria-labelledby="openModal"
		aria-hidden="true"
		data-backdrop="static"
	>
		<div class="modal-dialog modal-lg" role="document">
			<div
				class="modal-content campaign-g-addedit"
				style="width:1000px;height:260px;margin-left:-49px"
			>
				<div class="modal-header" style = "flex: 0 0 auto">
					<h5 class="modal-title" id="exampleModalLongTitle">{{title + ' - History'}}</h5>
					<button type="button" class="close" @click="resetPagination()" data-dismiss="modal">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" v-if="showSpinner">
					<div class="spinner-border" style="margin:auto;display:block"></div>
				</div>

				<div class="modal-body" style="font-size:14px" v-else-if="!showSpinner && descArray.length">
					<table class="table">
						<thead>
							<tr>
								<th>ML Strategy</th>
								<th>Time Created</th>
								<th style="text-align:right">Previous Bid($)</th>
								<th style="text-align:right">Current Bid ($)</th>
								<!-- <th>Reason</th> -->
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in (descArray)" :key="item +'_'+ index">
								<td width='15%'>{{modifyStrategyLabel(item.strategy)}}</td>
								<td width='15%'>{{getDateTime(item.time_created)}}</td>
								<td width='15%' style="text-align:right">{{(item.bid).toFixed(2)}}</td>
								<td width='15%' style="text-align:right">{{(item.rec_bid.toFixed(2))}}</td>
								<!-- <td width='45%' style="max-width:500px;word-wrap:break-word">{{item.bid_change_reason}}</td> -->
							</tr>
						</tbody>
					</table>
					<KeyDescFooter @fetchKeywordDescData='fetchKeywordDescData'/>
				</div>
				<div class="modal-body" v-else>
					<p class="ml-1">No items to display.</p>
				</div>
				<div class="modal-footer" style = "flex: 0 0 auto">
					<div style="text-align: center">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" @click="resetPagination()">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var moment = require("moment");
import KeyDescFooter from './KeyDescFooter.vue'
	export default {
		name: "DescriptionPopUp",
		data() {
			return {};
		},
		components:{
			KeyDescFooter
		},
		props: ["title", "showSpinner", 'descArray','id'],
		methods: {
			moment,
			modifyStrategyLabel(itemStrategy){
			switch(itemStrategy){
				case 'Exploitation':
					return 'Optimizing'
				
				case 'Need_based_Exploration':
				return 'Optimizing'
				
				case 'Fixed_increment':
				return 'Exploration'
				
				case 'Manually_managed':
				return 'Manually Managed'
				
				default:
					return itemStrategy;
			}

		},
			getDateTime(data){
				return moment(data).utc().format("YYYY-MM-DD hh:mm A")
			},
			openPopUp() {
				$("#keywordDescPopup").modal("show");
			},
			fetchKeywordDescData(){
				let obj = {
					keyword_text:this.title,
					asin:this.title
				}
				if(this.$route.params.sponsoredType == 'sd'){
					obj['target_id'] = this.id
				}
				else{
					obj['ams_keyword_id'] = this.id
				}
				this.$emit('fetchKeywordDesc',obj)
			},
			resetPagination(){
				this.$emit('resetPagination')
			}
		}
	};
</script>

<style>
.scroll {
	min-height: 350px !important;
	overflow: auto;
}
</style>
